import React from 'react'
// import Navbar from '../component/Navbar/Navbar'
// import Navbar2 from '../component/Navbar2'
import Naavbar from '../component/Navbar/Naavbar'
import Footer from '../component/Footer/Footer'

function Blog() {
  return (
    <div>
      <Naavbar/>
           {/* <Navbar2/> */}

    <div className="bg-[#02336c] py-20 px-4">
    <h1 className="text-white text-center font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl">BLOG</h1>
    </div>  

  <main>
  <br/>
  <br/>
  <br/>
  <br/>
 <br/>
 <br/>
 <h3 style={{color:'#21005d'}}><b className='flex justify-center text-lg'>  COMING SOON</b></h3>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
 <br/>
</main>

<Footer/>
</div>

  )
}

export default Blog